'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldState = exports.pickFieldState = undefined;

var _pick2 = require('lodash/fp/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _ary2 = require('lodash/ary');

var _ary3 = _interopRequireDefault(_ary2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.getHandler = getHandler;

var _reactRedux = require('react-redux');

var _capeRedux = require('cape-redux');

var _reduxField = require('redux-field');

var _FieldViewEl = require('./FieldViewEl');

var _FieldViewEl2 = _interopRequireDefault(_FieldViewEl);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var pickFieldState = exports.pickFieldState = (0, _pick3.default)(['isSaving', 'value']);
var getFieldState = exports.getFieldState = (0, _flow3.default)(_reduxField.getState, pickFieldState);
var getActions = (0, _capeRedux.mapDispatchToProps)(function (_ref) {
  var prefix = _ref.prefix;
  return {
    onClick: (0, _partial3.default)(_reduxField.open, prefix)
  };
});
var openPayload = (0, _pick3.default)(['id', 'initialValue']); // Only create a handler when the form is editable.

function getHandler(stateProps, dispatchProps, ownProps) {
  if (!ownProps.isEditable) return undefined;
  return (0, _ary3.default)((0, _partial3.default)(dispatchProps.onClick, openPayload(ownProps)));
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  var value = stateProps.isSaving && ownProps.isActive && stateProps.value || ownProps.initialValue;
  return _extends({}, ownProps, stateProps, {
    onClick: getHandler(stateProps, dispatchProps, ownProps),
    value: value
  });
}

exports.default = (0, _reactRedux.connect)(getFieldState, getActions, mergeProps)(_FieldViewEl2.default);